import { Card } from '@ipfabric/ui-components/Card/Card';
import { PageLayout } from '@ipfabric/ui-components/PageLayout/PageLayout';
import { Table } from 'components/Table/components/Table';
import { renderQuery } from 'utils/react-query/renderQuery';
import {
  ENDPOINT_POLICY_TITLE_BY_MODE,
  EndpointPolicyForm,
} from './EndpointPolicyForm';
import { useEndpointPoliciesTable } from './useEndpointPoliciesTable';

const description =
  'Endpoint policies group the API endpoints a role may call. They are linked ' +
  'to roles now and will replace legacy policies once enforcement moves to the ' +
  'new RBAC model.';

export const EndpointPoliciesPage = () => {
  const table = useEndpointPoliciesTable();

  // Like the legacy policies page, the editor replaces the table in-page so the
  // endpoint tree builder gets the full width.
  if (table.opened) {
    return (
      <PageLayout className='flex flex-col'>
        <h2>{ENDPOINT_POLICY_TITLE_BY_MODE[table.opened.mode]}</h2>
        <EndpointPolicyForm
          mode={table.opened.mode}
          policy={table.opened.policy}
          onClose={() => table.setOpened(null)}
        />
      </PageLayout>
    );
  }

  return (
    <div className='flex min-h-0 flex-1 flex-col p'>
      <Card className='flex min-h-0 flex-1 flex-col' noShadow>
        {renderQuery({
          query: table.policiesQuery,
          renderStaleDataOnMount: true,
          success: () => (
            <Table
              borderless
              className='flex-1 bg-transparent'
              columns={table.columns}
              description={description}
              disableTableRowDetail
              id='settings-administration-endpoint-policies'
              loadRowIdsForSelectAll='fromData'
              menuItems={table.menuItems}
              rowHeight={44}
              rowIdField='id'
              title='List of endpoint policies'
              {...table.frontendSimpleFilter}
            />
          ),
        })}
      </Card>
      {table.confirmDeleteDialog.render()}
    </div>
  );
};
